


import { useEffect, useState } from "react";


export const BusinessHeroSection = () => {

const [itemHeight, setItemHeight] = useState(60);

useEffect(() => {
  const updateHeight = () => {
    const w = window.innerWidth;
    if (w >= 1850) setItemHeight(120);
    else if (w >= 1199) setItemHeight(75);
    else setItemHeight(60);
  };

  updateHeight();
  window.addEventListener('resize', updateHeight);
  return () => window.removeEventListener('resize', updateHeight);
}, []);

  const rotatingTexts = [
    "Build Loyalty",
    "Clear Inventory",
    "Drive Foot Traffic",
    "Attract Locals",
    "Boost Revenue",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % rotatingTexts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="hidden min-[1200px]:block px-[80px]">
      <section className="w-full max-w-[1820px] flex justify-center py-12">

      <div className="w-full max-w-[1820px]  grid grid-cols-2  justify-evenlyx">

        {/* LEFT CONTENT */}
        <div className="w-full">

          {/* Trust badge */}
          <div className="inline-flex items-center gap-3 px-5 py-3 bg-white rounded-full shadow-md mb-8">
            <div className="w-3 h-3 rounded-full bg-red-500"/>
            <span className="text-gray-800 text-[16px]">
              Trusted by 500+ Local Businesses
            </span>
          </div>

          {/* Heading */}
          <h1
  className="leading-[1.2] font-medium text-gray-900"
  style={{
    fontSize: 'clamp(56px, calc(56px + (82 - 56) * ((100vw - 1199px) / (1850 - 1199))), 82px)',
  }}
>
  The Marketing
  <br />
  Platform Built to
</h1>

          {/* Rotating headline */}
          {/* Single responsive rotating text block */}
<div className="overflow-hidden mt-4 h-[60px] min-[1199px]:h-[75px] min-[1850px]:h-[120px]">
  <div
    className="transition-transform duration-500"
    style={{ transform: `translateY(-${currentIndex * itemHeight}px)` }}
  >
    {rotatingTexts.map((text, index) => (
       <div
        key={index}
        className="font-semibold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent"
        style={{
          fontSize: 'clamp(56px, calc(56px + (82 - 56) * ((100vw - 1199px) / (1850 - 1199))), 82px)',
          lineHeight: itemHeight + 'px',
        }}
      >
        {text}
      </div>
    ))}
  </div>
</div>

          {/* Description */}
          <p className="mt-6 text-gray-600 text-[18px] max-w-[520px] min-[1850px]:w-[450px]">
            Connect directly with locals ready to discover your deals.
            No commissions, no complexity—just results.
          </p>

          {/* Buttons */}
          <div className="flex gap-4 mt-8">

           <div className="flex items-center bg-gray-100 rounded-full w-fit">

  {/* Input */}
  {/* <div
    className="flex items-center gap-3 border-2 border-red-500 rounded-full"
    style={{
      padding: 'clamp(16px, calc(16px + (24 - 16) * ((100vw - 1199px) / (1850 - 1199))), 24px) clamp(20px, calc(20px + (32 - 20) * ((100vw - 1199px) / (1850 - 1199))), 32px)',
      width: 'clamp(320px, calc(320px + (520 - 320) * ((100vw - 1199px) / (1850 - 1199))), 520px)',
    }}
  >
    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
      style={{
        width: 'clamp(20px, calc(20px + (26 - 20) * ((100vw - 1199px) / (1850 - 1199))), 26px)',
        height: 'clamp(20px, calc(20px + (26 - 20) * ((100vw - 1199px) / (1850 - 1199))), 26px)',
        flexShrink: 0,
      }}
      className="text-gray-500"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 7.5v9a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 16.5v-9m19.5 0L12 13.5 2.25 7.5m19.5 0A2.25 2.25 0 0019.5 5.25h-15A2.25 2.25 0 002.25 7.5"
      />
    </svg>

    
    <input
      type="email"
      placeholder="Email"
      className="bg-transparent outline-none text-gray-700 placeholder-gray-500 w-full"
      style={{
        fontSize: 'clamp(14px, calc(14px + (18 - 14) * ((100vw - 1199px) / (1850 - 1199))), 18px)',
      }}
    />
  </div> */}

  

 
   <a
                href="https://mycouponbook.ca/signup/form"
    className="bg-gradient-to-r from-red-600 to-red-800 text-white rounded-full font-medium hover:scale-105 transition"
    style={{
      padding: 'clamp(14px, calc(14px + (20 - 14) * ((100vw - 1199px) / (1850 - 1199))), 20px) clamp(20px, calc(20px + (32 - 20) * ((100vw - 1199px) / (1850 - 1199))), 32px)',
      fontSize: 'clamp(14px, calc(14px + (18 - 14) * ((100vw - 1199px) / (1850 - 1199))), 18px)',
    }}
  >
    Sign Up Now
  </a>

</div>

          </div>

        </div>


        <div className="relative flex justify-center items-center w-[clamp(650px,55vw,950px)] transition-all duration-700 ease-out">

          {/*  TABLET */}
          <img
  src="/images/Webp/image-11.webp"
  className="relative z-10"
  style={{
    width: 'min(1200px, 62vw)',
    marginRight: 'clamp(36px, calc(36px + (112 - 36) * ((100vw - 1199px) / (1943 - 1199))), 112px)',
  }}
/>


          <div
  className="
    absolute
    top-[150px]
    w-[320px]
    rounded-[30px]
    overflow-hidden
    transbox
    border-[2.5px] border-white border-solid
    shadow-[0px_40px_80px_rgba(0,0,0,0.25)]
    animate-floatSlow
    z-30 mr-9
  "
  style={{
    right: 'clamp(10px, calc(10px + (200 - 10) * ((100vw - 1199px) / (1943 - 1199))), 50px)',
  }}
>
            <div className="grid grid-rows-1 ">
              <div className="col-span-2 ..."> <div className="px-6 py-4">
                <div className=" ">
                  <div className="flex items-center gap-3">

                    <img
                      src="/images/CB.svg"
                      className="w-[30px]"
                    />

                    <div className="text-lg font-semibold text-black">
                      Café Bliss
                    </div>

                  </div>
                </div>

              </div></div>
              <div className="col-span-2 row-span-2 ..."><div
                className="
              
                    relative
                    bgimg
                    rounded-[20px]
                    bg-cover
                    
                    bg-center
                    text-white
                    p-5
                  "
              >



                <div
                  className="
                    flex
                    items-center
                    justify-between
                   
                  "
                >

                  {/* LEFT TEXT */}
                  <div>
                    <div className="text-[18px] font-medium leading-none">
                      Deal Redeemed
                    </div>

                    <div className="text-[32px] font-normal leading-none mt-2">
                      20%
                      Off
                    </div>

                    <div className="text-sm opacity-90 mt-2">
                      Your Order
                    </div>
                  </div>


                  {/* VERIFIED BADGE */}
                  <div
                    className="
                          flex
                          items-center
                          gap-2
                          bg-white
                          text-black
                          px-4
                          py-2
                          rounded-full
                          shadow-sm
                        "
                  >

                    {/* ICON */}
                    <div className="
                          w-6 h-6
                          rounded-full
                          bg-red-600
                          flex
                          items-center
                          justify-center
                        ">
                      <img
                        src="/images/vector-7.svg"
                        className="w-3"
                      />
                    </div>

                    <span className="text-sm font-medium">
                      Verified
                    </span>

                  </div>

                </div>

              </div>
              </div>
            </div>

            {/* TOP RED IMAGE SECTION */}


            {/* BOTTOM WHITE SECTION */}


          </div>
        </div>

      

      </div>
      <style>{`

   

div.transbox {
  background-color: rgba(193, 120, 120, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  
  font-weight: bold;
} 
 
  .bgimg {
    background-image: url('/images/Webp/PersonalisedforYouRedCardBG.webp');
    background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

 `}</style>
    </section>
      </div>

      <div className="hidden md:block min-[1200px]:hidden px-[40px]">
      <section className="w-full  flex justify-center py-12">

      <div className="w-full   grid grid-cols-2  justify-evenlyx">

        {/* LEFT CONTENT */}
        <div className="w-full">

          {/* Trust badge */}
          <div className="inline-flex items-center gap-3 px-5 py-3 bg-white rounded-full shadow-md mb-8">
            <div className="w-3 h-3 rounded-full bg-red-500" />
            <span className="text-gray-800 text-[16px]">
              Trusted by 500+ Local Businesses
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-[42px] leading-[1.2] font-medium text-gray-900">
            The Marketing
            <br />
            Platform Built to
          </h1>

          {/* Rotating headline */}
          <div className="h-[80px] overflow-hidden ">
            <div
              className="transition-transform duration-500"
              style={{ transform: `translateY(-${currentIndex * 60}px)` }}
            >
              {rotatingTexts.map((text, index) => (
                <div
                  key={index}
                  className="text-[42px] font-semibold bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent"
                >
                  {text}
                </div>
              ))}
            </div>
          </div>

          {/* Description */}
          <p className="mt-6 text-gray-600 text-[16px] w-[420px] max-[1020px]:w-[350px] max-[845px]:w-[300px] ">
            Connect directly with locals ready to discover your deals.
            No commissions, no complexity—just results.
          </p>

        {/* <div className="flex items-center bg-gray-100 rounded-full w-[390px]  mt-6">

      <div className="flex items-center gap-3 border-2 border-red-500 rounded-full px-4 w-fit  space-x-3">
        
       
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21.75 7.5v9a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 16.5v-9m19.5 0L12 13.5 2.25 7.5m19.5 0A2.25 2.25 0 0019.5 5.25h-15A2.25 2.25 0 002.25 7.5"
          />
        </svg>

       
        <input
          type="email"
          placeholder="Email"
          className="bg-transparent outline-none text-gray-700 placeholder-gray-500 w-full"
        />
      </div>
<button
    className="bg-gradient-to-r from-red-600 to-red-800 text-white rounded-full font-medium hover:scale-105 transition"
    style={{
      padding: 'clamp(14px, calc(14px + (20 - 14) * ((100vw - 1199px) / (1850 - 1199))), 20px) clamp(20px, calc(20px + (32 - 20) * ((100vw - 1199px) / (1850 - 1199))), 32px)',
      fontSize: 'clamp(14px, calc(14px + (18 - 14) * ((100vw - 1199px) / (1850 - 1199))), 18px)',
    }}
  >
    Sign Up Now
  </button>
  
    </div> */}
      <a
  href="https://mycouponbook.ca/signup/form"
  className="block mt-6 w-fit bg-gradient-to-r from-red-600 to-red-800 text-white rounded-full font-medium hover:scale-105 transition text-[16px] py-4 px-8"
>
  Sign Up Now
</a>

        </div>

        {/* RIGHT IMAGE */}
        <div className="relative flex justify-center items-center w-[550px] max-[1020px]:w-[500px] max-[917px]:w-[450px]">

          {/*  TABLET */}
          <img
            src="/images/Webp/image-11.webp"
            className="w-[1200px] relative z-10 mr-9"
          />


          <div
            className="
                absolute
                top-[110px]
                right-[10px]
                w-[320px]
                rounded-[30px]
                overflow-hidden
                transbox
                border-[2.5px] border-white border-solid
                shadow-[0px_40px_80px_rgba(0,0,0,0.25)]
                animate-floatSlow
                z-30 mr-9
              "
          >
            <div className="grid grid-rows-1 ">
              <div className="col-span-2 ..."> <div className="px-6 py-4">
                <div className=" ">
                  <div className="flex items-center gap-3">

                    <img
                      src="/images/CB.svg"
                      className="w-[30px]"
                    />

                    <div className="text-lg font-semibold text-black">
                      Café Bliss
                    </div>

                  </div>
                </div>

              </div></div>
              <div className="col-span-2 row-span-2 ..."><div
                className="
                    relative
                    bgimg
                    rounded-[20px]
                    bg-cover
                    bg-center
                    text-white
                    p-5
                  "
              >



                <div
                  className="
                    flex
                    items-center
                    justify-between
                   
                  "
                >

                  {/* LEFT TEXT */}
                  <div>
                    <div className="text-[18px] font-medium leading-none">
                      Deal Redeemed
                    </div>

                    <div className="text-[32px] font-normal leading-none mt-2">
                      20%
                      Off
                    </div>

                    <div className="text-sm opacity-90 mt-2">
                      Your Order
                    </div>
                  </div>


                  {/* VERIFIED BADGE */}
                  <div
                    className="
                          flex
                          items-center
                          gap-2
                          bg-white
                          text-black
                          px-4
                          py-2
                          rounded-full
                          shadow-sm
                        "
                  >

                    {/* ICON */}
                    <div className="
                          w-6 h-6
                          rounded-full
                          bg-red-600
                          flex
                          items-center
                          justify-center
                        ">
                      <img
                        src="/images/vector-7.svg"
                        className="w-3"
                      />
                    </div>

                    <span className="text-sm font-medium">
                      Verified
                    </span>

                  </div>

                </div>

              </div>
              </div>
            </div>

            {/* TOP RED IMAGE SECTION */}


            {/* BOTTOM WHITE SECTION */}


          </div>
        </div>



      </div>
      <style>{`

   

div.transbox {
  background-color: rgba(193, 120, 120, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  
  font-weight: bold;
} 
 
  .bgimg {
    background-image: url('/images/Webp/PersonalisedforYouRedCardBG.webp');
    background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

 `}</style>
    </section>
      </div>

      <div className="block lg:hidden md:hidden px-[24px]">
      <section className="w-full flex justify-center  md:py-20 ">

      <div className="w-full max-w-[1200px] flex flex-col items-center text-center">

        {/* TOP BADGE */}
        <div className="flex items-center gap-2 bg-neutral-100 p-4 py-2 rounded-full mb-6">
          <div className="w-2 h-2 bg-red-600 rounded-full" />
          <span className="text-xs sm:text-sm text-neutral-700">
            Trusted by 500+ Local Businesses
          </span>
        </div>

        {/* TITLE */}
        <h2 className="
          text-[38px] sm:text-3xl md:text-[56px]
          leading-tight md:leading-[64px]
          font-semibold text-neutral-900 mb-4
        ">
          The Marketing Platform Built to
        </h2>

        {/* Rotating text - mobile */}
        <div className="overflow-hidden h-[48px] mb-4">
          <div
            className="transition-transform duration-500"
            style={{ transform: `translateY(-${currentIndex * 48}px)` }}
          >
            {rotatingTexts.map((text, index) => (
              <div
                key={index}
                className="h-[48px] flex items-center justify-center font-semibold text-[38px] bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent leading-none"
              >
                {text}
              </div>
            ))}
          </div>
        </div>

        {/* DESCRIPTION */}
        <p className="
          text-sm sm:text-base md:text-[18px]
          text-neutral-600
          max-w-[90%] md:max-w-[700px]
          mb-10
        ">
          Discover trusted local deals, earn rewards on every spend,
          and stretch your money further—without changing how you shop.
        </p>

        {/* IMAGE + CARD */}
        <div className="relative flex justify-center items-center w-full max-w-[650px] ">

          {/*  TABLET */}
          <img
            src="/images/Webp/image-112.webp"
            className="w-[360px]"
          />


          <div
            className="
                absolute
                top-[30px]
                right-[100px]
                w-[230px]
                rounded-[25px]
                overflow-hidden
                transbox
                border-[2.5px] border-white border-solid
                shadow-[0px_40px_80px_rgba(0,0,0,0.25)]
                animate-floatSlow
                z-30 mr-9
              "
          >
            <div className="grid grid-rows-1 ">
              <div className="col-span-2 ..."> <div className="px-6 py-4">
                <div className=" ">
                  <div className="flex items-center gap-3">

                    <img
                      src="/images/CB.svg"
                      className="w-[22px]"
                    />

                    <div className="text-[16px] font-semibold text-black">
                      Café Bliss
                    </div>

                  </div>
                </div>

              </div></div>
              <div className="col-span-2 row-span-2 ..."><div
                className="
              
                    relative
                    bgimg
                    rounded-[20px]
                    bg-cover
                    
                    bg-center
                    text-white
                    p-5
                  "
              >



                <div
                  className="
                    flex
                    items-center
                    justify-between
                   
                  "
                >

                  {/* LEFT TEXT */}
                  <div>
                    <div className="text-[10px] text-start font-medium leading-none">
                      Deal Redeemed
                    </div>

                    <div className="text-[16px] text-start font-normal leading-none mt-2">
                      20%
                      Off
                    </div>

                    <div className="text-[10px] text-start opacity-90 mt-2">
                      Your Order
                    </div>
                  </div>


                  {/* VERIFIED BADGE */}
                  <div
                    className="
                          flex
                          items-center
                          gap-2
                          bg-white
                          text-black
                          px-4
                          py-2
                          rounded-full
                          shadow-sm
                        "
                  >

                    {/* ICON */}
                    <div className="
                          w-[18px] h-[18px]
                          rounded-full
                          bg-red-600
                          flex
                          items-center
                          justify-center
                        ">
                      <img
                        src="/images/vector-7.svg"
                        className="w-[10px] h-[10px]"
                      />
                    </div>

                    <span className="text-[10px] font-medium">
                      Verified
                    </span>

                  </div>

                </div>

              </div>
              </div>
            </div>

            {/* TOP RED IMAGE SECTION */}


            {/* BOTTOM WHITE SECTION */}


          </div>
        </div>

        {/* BUTTONS */}
        {/* <div className="flex gap-4 mt-8">

            <button className="px-4 py-4 rounded-full hover:scale-105
    transition bg-gradient-to-r from-red-600 to-red-700 text-white font-medium text-[12px]">
              Publish a Deal — Free
            </button>

            <button
              className="
    flex
    items-center
    gap-2
    px-8
    py-4
    rounded-full
    bg-white/80
    backdrop-blur-md
    shadow-[0px_0px_30px_10px_rgba(0,0,0,0.08)]
    text-red-600
    font-medium
    text-[12px]
    hover:scale-105
    transition
  "
            >

              
              <img
                src="/images/Polygon.svg"
                className="w-[15px]"
              />

              Watch Demo

            </button>

          </div> */}
           <a
                href="https://mycouponbook.ca/signup/form"
    className=" mt-10 w-[220px] bg-gradient-to-r from-red-600 to-red-800 text-white rounded-full font-medium hover:scale-105 transition"
    style={{
      padding: 'clamp(14px, calc(14px + (20 - 14) * ((100vw - 1199px) / (1850 - 1199))), 20px) clamp(20px, calc(20px + (32 - 20) * ((100vw - 1199px) / (1850 - 1199))), 32px)',
      fontSize: 'clamp(14px, calc(14px + (18 - 14) * ((100vw - 1199px) / (1850 - 1199))), 18px)',
    }}
  >
    Sign Up Now
  </a>

      </div>
    </section>
      </div>
    </div>
    
  );
};